import styled from '@emotion/styled';

import { tokens } from '@hotjar/hotsauce';
import { localeNumber } from '@hotjar/insights-common/lib/number';

import { useTranslatedClickEvent } from '../Heatmaps/use-translated-click-event';

const StyledStatsContainer = styled.div`
  ${tokens.text('subtitle1')}
  padding: ${tokens.spacer.x1pt5} ${tokens.spacer.x2};
  color: ${tokens.color.text_default};
  background: ${tokens.color.bg_active};
  border-radius: ${tokens.spacer.x0};
`;

interface ClickStatsDialogProps {
  isDesktop: boolean;
  clicksCount: number;
  clicksPercentage: number;
  className?: string;
}

export const ClickStatsDialog = ({
  clicksCount,
  clicksPercentage,
  isDesktop,
  className,
}: ClickStatsDialogProps): JSX.Element | null => {
  const eventName = useTranslatedClickEvent({
    count: clicksCount,
    isDesktop,
  });

  const isVisible = clicksCount > 0 && clicksPercentage > 0;

  if (!isVisible) {
    return null;
  }

  return (
    <StyledStatsContainer className={className}>
      {localeNumber(clicksCount)} {eventName} ({localeNumber(clicksPercentage)}%)
    </StyledStatsContainer>
  );
};
